module.exports = __webpack_public_path__ + "img/error_404.61e35cdb.svg";